<template>
  <div class="section youkoso-parent">
    <div class="youkoso">

      <div class="gears-parent">
        <Gear/>
      </div>

      <div class="columns">
        <div class="column ">
          <img class="youkosoimg" src="../../assets/Main/youkoso.png"/>
        </div>
      </div>
    </div>
    <div class="youkoso-text">
      広大なる<span class="rubys">「<ruby>La Kasketia<rt>ラ・カスケティア</rt></ruby>」</span>への誘い...
    </div>
    <div class="gaiyou">
      "ファンタジー系MMORPG"をコンセプトとしたサウンドトラック集。<br>
      toyKasketと豪華ゲスト陣による冒険の旅へ、足を踏み入れてみませんか？
    </div>
  </div>
</template>

<script>
  import Gear from '../Parts/Gear'

  export default {
    name: "Youkoso",
    components: {
      Gear
    }
  }
</script>

<style scoped lang="scss">
  .youkoso-parent {
    position: relative;
    background: url('../../assets/Loading/bg-loading.png') repeat;
    z-index: 2;
    animation: move-bg 10s infinite linear;
    &:before {
      content: '';
      position: absolute;
      height: 100%;
      width: 10vw;
      top: 0;
      left: 0;
      background: #2c3e50;
      overflow: hidden;
      opacity: 0.5;
    }

    &:after {
      content: '';
      position: absolute;
      height: 100%;
      width: 10vw;
      top: 0;
      right: 0;
      background: #2c3e50;
      overflow: hidden;
      opacity: 0.5;
    }
  }

  @keyframes move-bg {
    0% {
      background-position: 0 0;
    }

    100% {
      background-position: 375px 302px;
    }
  }

  .youkoso {
    display: flex;
    justify-content: center;
    position: relative;
  }

  .youkosoimg {
    position: relative;
    max-height: 120px;
    z-index: 1;
    image-rendering: auto;
    animation: tenmetsu 5s ease-in infinite;
  }

  @keyframes tenmetsu {
    0% {
      opacity: 0.7;
    }

    50% {
      opacity: 1;
    }

    100% {
      opacity: 0.7;
    }
  }

  .youkoso-text {
    position: relative;
    margin-top: 25px;
    margin-bottom: 25px;
    color: #f8f3d9;
    font-size: x-large;
    font-weight: bold;
    font-style: italic;
    text-align: center;
    @media screen and (max-width: 768px) {
      font-size: small;
    }
    .rubys {
      font-size: xx-large;
      @media screen and (max-width: 768px) {
        font-size: medium;
      }
    }
  }

  .gaiyou {
    position: relative;
    margin-top: 25px;
    margin-bottom: 25px;
    color: #fff3af;
    font-size: medium;
    font-weight: bold;
    font-style: italic;
    text-align: center;
    @media screen and (max-width: 768px) {
      font-size: small;
    }
  }

  .gears-parent {
    position: absolute;
    width: 250px;
    margin-top: 40px;
    left: 47%;
    @media screen and (max-width: 768px) {
      width: 40%;
      left: 38%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Sections/Youkoso.vue